"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UISpriteGameObject = void 0;
var render3DGameObject_1 = require("./render3DGameObject");
var realms_three_1 = __importDefault(require("realms-three"));
var canvas_ui_1 = require("canvas-ui");
var UISpriteGameObject = /** @class */ (function (_super) {
    __extends(UISpriteGameObject, _super);
    function UISpriteGameObject(declarations, options) {
        var e_1, _a;
        var _this = _super.call(this, new realms_three_1.default.Sprite(new realms_three_1.default.SpriteMaterial({ toneMapped: false }))) || this;
        _this.rawUINode = null;
        /**
         * When there is a UI Update
         */
        _this.onRender = function () {
            var _a;
            var sprite = _this.getThreeObject();
            if (sprite instanceof realms_three_1.default.Sprite) {
                (_a = sprite.material.map) === null || _a === void 0 ? void 0 : _a.dispose();
                sprite.material.map = new realms_three_1.default.CanvasTexture(_this.htmlCanvas);
                sprite.material.toneMapped = false;
            }
        };
        _this.setScale({
            x: options.canvasWidth * options.scale,
            y: options.canvasHeight * options.scale,
            z: 0,
        });
        _this.htmlCanvas = document.createElement("canvas");
        _this.htmlCanvas.width = options.canvasWidth;
        _this.htmlCanvas.height = options.canvasHeight;
        var ctx = _this.htmlCanvas.getContext("2d");
        if (!ctx) {
            throw new Error("Unable to get CanvasRenderingContext2D");
        }
        _this.ctx = ctx;
        _this.dom = new canvas_ui_1.UIDOM(_this.ctx, { onRender: _this.onRender });
        try {
            for (var _b = __values(Object.entries(declarations)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), t = _d[0], c = _d[1];
                _this.dom.declare(t, c);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _this;
    }
    UISpriteGameObject.prototype.setSpriteScale = function (scale) {
        this.setScale({
            x: this.htmlCanvas.width * scale,
            y: this.htmlCanvas.height * scale,
            z: 0,
        });
    };
    /**
     * Renders the given UI
     */
    UISpriteGameObject.prototype.render = function (node) {
        this.rawUINode = node;
    };
    UISpriteGameObject.prototype.onInit = function (scene) {
        _super.prototype.onInit.call(this, scene);
        if (this.rawUINode) {
            this.dom.render(this.rawUINode);
        }
    };
    UISpriteGameObject.prototype.onRemove = function (scene) {
        var _a;
        _super.prototype.onRemove.call(this, scene);
        this.dom.stopRender();
        var sprite = this.getThreeObject();
        if (sprite instanceof realms_three_1.default.Sprite) {
            (_a = sprite.material.map) === null || _a === void 0 ? void 0 : _a.dispose();
        }
    };
    return UISpriteGameObject;
}(render3DGameObject_1.Render3DGameObject));
exports.UISpriteGameObject = UISpriteGameObject;
